import actionTypes from '../actions/reduxActions/actionTypes';
import { append } from 'ramda';

const configPanel = (state = [], { type, payload, error, meta }) => {

    switch (type) {

    case actionTypes.MAP_ELEMENT_DROP: {
        const configPanelSettings = {
            component: payload.configComponent,
            props: payload.configProps,
            flowId: payload.flowId,
        };
        return append(configPanelSettings, state);
    }

    case actionTypes.GRAPH_ESCAPE_KEY:
    case actionTypes.MAP_ELEMENT_CONFIGURATION_DISMISS:
    case actionTypes.FLOW_CLOSE:
        return state.filter(config => payload !== config.flowId);

    default:
        return state;
    }
};

export default configPanel;
